module.exports = __webpack_public_path__ + "30d608cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Slide/ic_right.png
// module id = 1014
// module chunks = 1 2